export default __webpack_public_path__ + "static/logo_white-66675db888ba00237d99d8d1fa89e7ee.svg";